<template>
    <div class="user">
        <!--报考费用-->
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="blue f14 fb">报考费用</span>
            </div>
            <div class="text f14">
                <div class="item">报考专业: {{ signDetail.major.major_name }}</div>
                <div class="item">报考时间: {{ signDetail.create_time }}</div>
                <div class="item">考试费用:  <el-tag type="warning" effect="dark"><span class="f16">{{ signDetail.major.fee }} 元</span></el-tag></div>
            </div>
        </el-card>

        <!--支付方式-->
        <el-card class="box-card" v-if="signDetail.status.value == 20 && signDetail.pay_status.value == 10">
            <div slot="header" class="clearfix">
                <span class="blue f14 fb">支付方式</span>
            </div>
            <div class="text f14">
                <el-button type="success">
                    <span class="icon iconfont menu-item-icon icon-weixinzhifu"> 微信支付</span>
                </el-button>
            </div>
        </el-card>

        <!--缴费状态-->
        <el-card class="box-card" v-if="signDetail.status.value == 20 && signDetail.pay_status.value == 20">
            <div slot="header" class="clearfix">
                <span class="blue f14 fb">缴费状态</span>
            </div>
            <div class="text f14">
                <div class="item">支付单号: {{ signDetail.transaction_id }}</div>
                <div class="item">支付方式: 通联支付</div>
                <div class="item">支付时间: {{ signDetail.pay_time }}</div>
                <div class="item">实付金额: {{ signDetail.major.fee }}</div>
                <div class="item">支付结果:  <el-tag type="success" effect="dark"><span class="f16">缴费成功</span></el-tag></div>
            </div>
        </el-card>

        <div class="common-button-wrapper" v-if="signDetail.status.value == 20 && signDetail.pay_status.value == 10">
            <el-button size="small" type="primary" :loading="loading" @click="pay">确认支付</el-button>
        </div>

        <!--微信支付-->
        <el-dialog title="微信支付" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="700px">
            <div class="centent">
                <div class="title-top">
                    <div style="margin: auto 25%;">
                        <div class="fb p-10-0">物业协会职业技能等级认定报考缴费</div>
                        <div class="fb p-10-0">支付金额: <span class="green f24">￥{{ signDetail.major.fee }}</span></div>
                    </div>
                </div>

                <div class="pay-qrcode">
                    <div>
                        <img :src="payImg" alt="" style="width: 240px;height: 240px;">
                        <div class="pay-tip">请打开手机微信，扫一扫完成支付</div>
                    </div>
                    <div style="margin-left: 50px;">
                        <img src="../../assets/img/wechat.png" alt="">
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import SignApi from '@/api/sign.js';
    import { getCookie } from '@/utils/base.js';
    import QRCode from 'qrcode'

    export default {
        data() {
            return {
                // 是否加载完成
                loading: true,
                token: getCookie('token_supplier'),
                sign_id: '',
                signDetail: {
                    major: {},
                    status: {
                        value: ''
                    },
                    pay_status: {
                        value: ''
                    },
                },
                dialogVisible: false,
                payImg: '',
            };
        },
        created() {
            this.sign_id = this.$route.query.sign_id

            // 获取数据
            this.getDetail();
        },
        methods: {
            // 获取报名详情
            getDetail() {
                let that = this;

                SignApi.getSignDetail({
                    sign_id: that.sign_id,
                    token: that.token
                }).then(res => {
                    that.signDetail = res.data.data

                    that.loading = false;
                }).catch(error => {

                });
            },

            // 确认支付
            pay(){
                let that = this;

                let loading = this.$loading({
                    lock: true,
                    text: '正在生成支付,请等待',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })

                SignApi.getSignPay({
                    sign_id: that.sign_id,
                    token: that.token
                }).then(res => {
                    QRCode.toDataURL(
                        res.data.data, {
                            errorCorrectionLevel: 'Q',
                        }
                    )
                    .then((url) => {
                        // 获取到url后即可在页面使用--二维码图片
                        this.payImg = url
                    })
                    .catch((e) => {
                        console.log('e', e)
                    });

                    that.loading = false
                    loading.close()
                    that.dialogVisible = true
                }).catch(error => {
                    loading.close()
                    that.$message({
                        message: '支付失败',
                        type: 'warning'
                    })
                });
            },

            // 关闭弹窗
            dialogFormVisible() {
                this.dialogVisible = false
            }

        }
    };
</script>

<style lang="scss" scoped>
    .box-card{
        margin-bottom: 15px;
        .text{
            .item{
                margin-bottom: 10px;
            }
        }
    }
    .common-button-wrapper{
        bottom: 60px;
    }
    .centent{
        .title-top{
            color: #000;
            border-bottom: 1px solid #eee;
        }
    }
    .pay-qrcode{
        display: flex;
        margin: auto 25%;
        padding: 50px 0;
        img{
            width: 200px;
        }
        .pay-tip{
            background-color: #00c800;
            color: #fff;
            line-height: 30px;
            text-align: center;
            margin-top: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/fee/detail.vue